import { Button, SvgIcon, UploadArea } from '@quicktools/shared-components';
import IconPlusLarge from '@picsart/icons/IconPlusLarge';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { appConfig } from '../../configs';
import { SvgIcons } from '../../utils/constants';
import { UploadFilePosition } from '../../utils/enums';
import { UploadType } from '../../utils/types';

import useStyles from './styles';
import { IUploadImageArea } from './types';

const { accept, multiple } = appConfig;

function UploadImageArea({ handleUpload, showImage = false }: IUploadImageArea) {
  const classes = useStyles({ showImage: showImage });
  const [uploadType, setUploadType] = useState<UploadType>('drag_and_drop');
  const { t } = useTranslation();
  return (
    <UploadArea
      onUpload={(files) => handleUpload(files, UploadFilePosition.UPLOAD_AREA, uploadType)}
      className={classes.stickyUpload}
      accept={accept}
      multiple={multiple}
    >
      <>
        {showImage && <SvgIcon className={classes.imageContainer} url={SvgIcons.noImageIcon} />}
        <p className={classes.uploadText}>{t('home.heroBanner.uploadAreaText')}</p>
        <Button className={classes.button} onClick={() => setUploadType('button')}>
          <IconPlusLarge />
          {t('home.heroBanner.buttonText')}
        </Button>
      </>
    </UploadArea>
  );
}
export default UploadImageArea;
